import { render, staticRenderFns } from "./ModaDeleteSite.vue?vue&type=template&id=0bd31158&"
import script from "./ModaDeleteSite.vue?vue&type=script&lang=js&"
export * from "./ModaDeleteSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports